import { render, staticRenderFns } from "./form-title.vue?vue&type=template&id=9008201e&scoped=true&"
import script from "./form-title.vue?vue&type=script&lang=ts&"
export * from "./form-title.vue?vue&type=script&lang=ts&"
import style0 from "./form-title.vue?vue&type=style&index=0&id=9008201e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9008201e",
  null
  
)

export default component.exports